<div class="form-group">
  @if (showLabel && (question?.question_copy || question?.email_version || controlLabel)) {
    <label class="form-group__label"
      [innerHtml]="(question?.question_copy || question?.email_version) && !showControlLabel ? (question?.question_copy || question?.email_version) : controlLabel">
    </label>
  }
  @if (showSkip) {
    <div class="question-skip">
      <label class="selection">
        <input
          type="checkbox"
          [checked]="skipped"
          [(ngModel)]="skipped"
          (ngModelChange)="onSkipChange()"
          name="add-note-toggle"
          id="skip-driver-details-toggle">
          <div class="selection__inner">
            <div class="selection__main">
              <div class="selection__left">
                <div class="selection__switch"></div>
              </div>
              <div class="selection__content">
                <div class="selection__label">
                  <div class="selection__title">Skip for now</div>
                </div>
              </div>
            </div>
          </div>
        </label>
      </div>
    }
    <div class="input-wrap">
      <input type="text" class="form-control form-control--datepicker" [placeholder]="placeHolder" value="" [id]="'picker' + index" readonly="">
      @if (displayInline || showIcon) {
        <div class="input-wrap-append">
          <div class="input-wrap-icon pointer" (click)="openDatepicker()">
            <svg class="icon" style="cursor: pointer;">
              <use xlink:href="#calendar"></use>
            </svg>
          </div>
        </div>
      }
    </div>
    @if (displayInline) {
      <div class="ui-datepicker__inline" [id]="'picker-inline' + index"></div>
    }
  </div>
